import POIConferenceRoomsEditDialog from "@/components/POI/POIConferenceRoomsEditDialog/POIConferenceRoomsEditDialog.vue";
import cloneDeep from "lodash/cloneDeep";

const defaultConferenceRoom = {
  area: 0,
  maxPeople: 0,
  title: "",
  features: [],
  seating: {
    uForm: 0,
    block: 0,
    parliamentary: 0,
    row: 0,
    circle: 0,
    theatre: 0,
    banquet: 0,
    standing: 0,
    fishbone: 0
  },
  pictures: []
};

export default {
  name: "POIConferenceRoomsFields",
  components: { POIConferenceRoomsEditDialog },
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    headers: [
      { text: "Bezeichnung", value: "title", sortable: false },
      { text: "Gesamtfläche (m2)", value: "area", sortable: false },
      { text: "Max. Fassungsvermögen", value: "maxPeople", sortable: false },
      { text: "Aktionen", value: "actions", sortable: false }
    ],
    itemsPerPage: 10,
    pageCount: 0,
    page: 1,
    roomEditDialog: false,
    editedRoomIndex: -1,
    editedRoom: {}
  }),
  methods: {
    addConferenceRoom() {
      this.editedItem.conferenceInfos.rooms.push(
        cloneDeep(defaultConferenceRoom)
      );
      const index = this.editedItem.conferenceInfos.rooms.length - 1;
      this.editRoom(this.editedItem.conferenceInfos.rooms[index], index);
    },
    removeConferenceRoom(index) {
      if (index < 0) return;
      this.editedItem.conferenceInfos.rooms.splice(index, 1);
    },
    editRoom(room, index) {
      if (index < 0) return;
      this.editedRoomIndex = index;
      const clonedRoom = cloneDeep(room);
      if (!Array.isArray(clonedRoom.features)) {
        clonedRoom.features = [];
      }
      this.editedRoom = clonedRoom;
      this.roomEditDialog = true;
    },
    closeRoomEdit(room) {
      if (room) {
        this.editedItem.conferenceInfos.rooms[this.editedRoomIndex] = cloneDeep(
          room
        );
        this.editedItem.conferenceInfos.rooms.reverse().reverse();
      }
      this.roomEditDialog = false;
      this.editedRoomIndex = -1;
      this.editedRoom = {};
    },
    removeRoom(room, index) {
      if (index < 0) return;
      this.editedItem.conferenceInfos.rooms.splice(index, 1);
    },
    moveUp(array, element) {
      this.move(array, element, -1);
    },
    moveDown(array, element) {
      this.move(array, element, 1);
    },
    move(array, element, delta) {
      const index = array.indexOf(element);
      const newIndex = index + delta;
      if (newIndex < 0 || newIndex === array.length) {
        return;
      }
      const indexes = [index, newIndex];
      indexes.sort();
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
    },
    nextPage() {
      const total = this.conferenceRoomsCount;
      const perPage = this.itemsPerPage;
      const totalPages = Math.ceil(total / perPage);
      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    }
  },
  computed: {
    isReadOnly() {
      return this.isOwnedBySubPrincipal;
    },
    conferenceRoomsCount() {
      return this.editedItem.conferenceInfos.rooms?.length ?? 0;
    }
  }
};
